import '../../../../assets/css/screens/admin/dashboard/settings/AdminSetting.css';
import { Globe, Bell } from 'lucide-react';
import axios from "axios";
import { useEffect, useState, useContext } from "react";
import AppContext from '../../../../context/AppContext';

// ── Toggle Component ──────────────────────────────────────────
const Toggle = ({ checked, onChange }) => (
  <button
    className={`as-toggle ${checked ? "as-toggle--on" : ""}`}
    onClick={() => onChange(!checked)}
    role="switch"
    aria-checked={checked}
    type="button"
  >
    <span className="as-toggle-thumb" />
  </button>
);

const AdminSetting = () => {

  const { baseUrl } = useContext(AppContext);

  const [platform_name, setPlatform_name] = useState('');
  const [support_email, setSupport_email] = useState('');
  const [platform_fee, setPlatform_fee] = useState('');
  const [email_notification, setEmail_notification] = useState(true);
  const [push_system, setPush_system] = useState(true);

  const [saved, setSaved] = useState(false);

  // ── View Settings ──────────────────────────────────────────
  const view = () => {
    axios.get(
      `${baseUrl}/setting`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken") || ""}`
        }
      }
    )
      .then((res) => {

        const data = res.data.setting;

        setPlatform_name(data.platform_name);
    setSupport_email(data.support_email);
    setPlatform_fee(data.platform_fee);
    setEmail_notification(data.email_notification);
    setPush_system(data.push_system);

      })
      .catch((err) => {
        console.log(err);
      });
  };

  // ── Update Settings ──────────────────────────────────────────
  const updateSetting = (
  emailValue = email_notification,
  pushValue = push_system
) => {

  const formData = new FormData();

  formData.append('platform_name', platform_name);
  formData.append('support_email', support_email);
  formData.append('platform_fee', platform_fee);

  formData.append('email_notification', emailValue ? 1 : 0);
  formData.append('push_system', pushValue ? 1 : 0);

  axios.post(
    `${baseUrl}/update-setting`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken") || ""}`
      }
    }
  )
}

  useEffect(() => {
    view();
  }, []);

  return (
    <div className="as-page">
      <div className="as-container">

        <h2 className="as-heading">Settings</h2>

        {/* ════ GENERAL ════ */}
        <div className="as-card" style={{ '--as-delay': '0s' }}>
          <div className="as-card-title">
            <span className="as-card-icon">
              <Globe size={16} />
            </span>
            General
          </div>

          <div className="as-field">
            <label className="as-label">Platform Name</label>
            <input
              className="as-input"
              type="text"
              value={platform_name}
              onChange={(e) => setPlatform_name(e.target.value)}
            />
          </div>

          <div className="as-field">
            <label className="as-label">Support Email</label>
            <input
              className="as-input"
              type="email"
              value={support_email}
              onChange={(e) => setSupport_email(e.target.value)}
            />
          </div>

          <div className="as-field">
            <label className="as-label">Platform Fee (%)</label>
            <input
              className="as-input"
              type="number"
              value={platform_fee}
              onChange={(e) => setPlatform_fee(e.target.value)}
              min="0"
              max="100"
            />
          </div>

          <button
            className={`as-save-btn ${saved ? 'as-save-btn--saved' : ''}`}
            onClick={updateSetting}
            type="button"
          >
            {saved ? 'Saved Successfully ✓' : 'Save Settings'}
          </button>
        </div>

        {/* ════ NOTIFICATIONS ════ */}
        <div className="as-card" style={{ '--as-delay': '0.08s' }}>
          <div className="as-card-title">
            <span className="as-card-icon">
              <Bell size={16} />
            </span>
            Notifications
          </div>

          <div className="as-toggle-row">
            <span className="as-toggle-label">
              Email notifications for new bookings
            </span>
            <Toggle
              checked={email_notification}
              onChange={(value) => {
                setEmail_notification(value);
                updateSetting(value, push_system);
              }}
            />
          </div>

          <div className="as-toggle-row">
            <span className="as-toggle-label">
              Push notifications for system events
            </span>
            <Toggle
              checked={push_system}
              onChange={(value) => {
                setPush_system(value);
                updateSetting(email_notification, value);
              }}
            />
          </div>
        </div>

      </div>
    </div>
  );
};

export default AdminSetting; 